<template>
  <select :value="value" @change="input" v-on="listeners">
    <option value="">with no other animation</option>
    <option value="shake">with a shake</option>
    <option value="shake horizontally">with a horizontal shake</option>
    <option value="shake vertically">with a vertical shake</option>
    <option value="pulsate">with a pulse</option>
    <option value="wave">with a wave</option>
    <option value="flash">with a flash</option>
  </select>
</template>

<script>
import BaseSelect from "./BaseSelect";

export default {
  name: "ChainableAnimationSelect",
  extends: BaseSelect
};
</script>

<style lang="css"></style>
